import React, { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import "./assets/css/meucorreios/inicio-reset.css";
import Header from "./components/template/Header";
import Home from "./pages/Home";
import AbirNovaSessao from "./pages/AbrirNovaSessao";
import { GlobalStorage } from "./store/GlobalContext";
import { AuthStorage } from "./store/AuthContext";
import AuthCallback from "./components/auth/AuthCallback";
import Alerta from "./components/alerta/Alerta";
import ModalConfirmacao from "./components/modal/ModalConfirmacao";
import NotFound from "./components/template/NotFound";
import ModalInformacao from "./components/modal/ModalInformacao";
import LoginMeuCorreios from "./pages/login/LoginMeuCorreios";
import CadastroPF from "./pages/login/Cadastro/CadastroPF";
import CadastroPJ from "./pages/login/Cadastro/CadastroPJ";
import SelecaoPerfil from "./pages/login/Cadastro/SelecaoPerfil";
import EsqueciSenha from "./pages/login/Cadastro/EsqueciSenha";
import CadastroFinalizado from "./pages/login/Cadastro/CadastroFinalizado";
import CadastroNaoRealizado from "./pages/login/Cadastro/CadastroNaoRealizado";
import TelaPrincipal from "./pages/login/Principal/TelaPrincipal";
import TelaPrincipalPF from "./pages/login/Principal/TelaPrincipalPF";
import TelaPrincipalPJ from "./pages/login/Principal/TelaPrincipalPJ";
import TelaEndereco from "./pages/login/Principal/Endereco/TelaEndereco";
import TelaNovoEndereco from "./pages/login/Principal/Endereco/TelaNovoEndereco";
import TelaAlterarEndereco from "./pages/login/Principal/Endereco/TelaAlterarEndereco";
import FormAlterarDadosEstrangeiro from "./pages/login/Principal/FormAlterarDadosEstrangeiro";
import FormAlterarDadosBrasileiro from "./pages/login/Principal/FormAlterarDadosBrasileiro";
import FormAlterarDadosPJBrasil from "./pages/login/Principal/FormAlterarDadosPJBrasil";
import FormAlterarDadosPJForaBrasil from "./pages/login/Principal/FormAlterarDadosPJForaBrasil";
import TelaDependentes from "./pages/login/Principal/Dependente/TelaDependentes";
import TelaNovoDependente from "./pages/login/Principal/Dependente/TelaNovoDependente";
import TelaAlterarDependente from "./pages/login/Principal/Dependente/TelaAlterarDependente";
import FinalizaCadastroToken from "./pages/login/Cadastro/FinalizaCadastroToken";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/css/custom-toast.css";
import RedefinirSenha from "./pages/login/Cadastro/RedefinirSenha";
import EsqueciMinhaSenhaPF from "./pages/login/Cadastro/EsqueciMinhaSenhaPF";
import EsqueciMinhaSenhaPFSemCPF from "./pages/login/Cadastro/EsqueciMinhaSenhaPFSemCPF";
import EsqueciMinhaSenhaPJ from "./pages/login/Cadastro/EsqueciMinhaSenhaPJ";
import EsqueciMinhaSenhaPJAN8 from "./pages/login/Cadastro/EsqueciMinhaSenhaPJAN8";
import Recadastramento from "./pages/login/Cadastro/Recadastramento";
import TelaPermissoesRecebidasSistemas from "./pages/login/Principal/PermissoesRecebidas/TelaPermissoesRecebidasSistemas";
import TelaPermissoesRecebidasContratos from "./pages/login/Principal/PermissoesRecebidas/TelaPermissoesRecebidasContratos";
import FormHistoricoToken from "./pages/login/Principal/FormHistoricoToken";
import TelaPermitirTerceiroDelegar from "./pages/login/Principal/TerceirosDeleguem/TelaPermitirTerceiroDelegar";
import TelaDelegacaoAcesso from "./pages/login/Principal/DelegacaoAcesso/TelaDelegacaoAcesso";
import TelaDelegacaoInclusao from "./pages/login/Principal/DelegacaoAcesso/TelaDelegacaoInclusao";
import TelaDelegacaoEdicao from "./pages/login/Principal/DelegacaoAcesso/TelaDelegacaoEdicao";
import Footer from "./components/template/Footer";
//import TelaPermissaoSistema from './pages/login/Principal/DelegacaoAcesso///TelaPermissaoSistema';
import ErroApp from "./components/auth/ErroApp";
import { UserStorage } from "./store/UserContext";
import ProtectedPasswordResetRoute from "./components/auth/ProtectedPasswordResetRoute";
import RedefinirSenhaObrigatoria from "./pages/login/RedefinirSenhaObrigatoria";

function App() {
  const [dados, setDados] = useState({ dados: "" });
  const origem = window.localStorage.getItem("origem");
  return (
    <>
      <BrowserRouter>
        <GlobalStorage>
          <AuthStorage>
            {/*origem && origem == 'meuCorreios' && <Header />*/}
            <UserStorage>
              {origem === "meuCorreios" && <Header />}
              <main>
                <Routes>
                  <Route path="/login" element={<LoginMeuCorreios />} />
                  <Route path="/cadastroPF" element={<CadastroPF />} />
                  <Route path="/cadastroPJ" element={<CadastroPJ />} />
                  <Route path="/selecionaPerfil" element={<SelecaoPerfil />} />
                  <Route path="/esqueciSenha" element={<EsqueciSenha />} />
                  <Route path="/redefinirSenha" element={<RedefinirSenha />} />
                  <Route
                    path="/redefinir-senha-obrigatoria"
                    element={
                      <ProtectedPasswordResetRoute>
                        <RedefinirSenhaObrigatoria />
                      </ProtectedPasswordResetRoute>
                    }
                  />
                  <Route
                    path="/recadastramento"
                    element={<Recadastramento dados={dados} />}
                  />
                  <Route
                    path="/cadastroFinalizado"
                    element={<CadastroFinalizado />}
                  />
                  <Route
                    path="/cadastroNaoRealizado"
                    element={<CadastroNaoRealizado />}
                  />
                  <Route
                    path="/finalizaCadastroToken"
                    element={<FinalizaCadastroToken />}
                  />
                  <Route path="/erroApp" element={<ErroApp />} />
                  <Route
                    path="/principal"
                    element={<TelaPrincipal setDados={setDados} />}
                  />
                  <Route
                    path="/principalPJ"
                    element={<TelaPrincipalPJ setDados={setDados} />}
                  />
                  <Route path="/principalPF" element={<TelaPrincipalPF />} />
                  <Route
                    path="/endereco"
                    element={<TelaEndereco dados={dados} />}
                  />
                  <Route path="/novoEndereco" element={<TelaNovoEndereco />} />
                  <Route
                    path="/alterarEndereco"
                    element={<TelaAlterarEndereco />}
                  />
                  <Route
                    path="/dadosBrasileiro"
                    element={<FormAlterarDadosBrasileiro dados={dados} />}
                  />
                  <Route
                    path="/dadosEstrangeiro"
                    element={<FormAlterarDadosEstrangeiro dados={dados} />}
                  />
                  <Route
                    path="/dadosPJBrasil"
                    element={<FormAlterarDadosPJBrasil dados={dados} />}
                  />
                  <Route
                    path="/dadosPJForaBrasil"
                    element={<FormAlterarDadosPJForaBrasil dados={dados} />}
                  />
                  <Route
                    path="/permissoesRecebidasSistemas"
                    element={<TelaPermissoesRecebidasSistemas dados={dados} />}
                  />
                  <Route
                    path="/permissoesRecebidasContratos"
                    element={<TelaPermissoesRecebidasContratos dados={dados} />}
                  />
                  <Route
                    path="/dependentes"
                    element={<TelaDependentes dados={dados} />}
                  />
                  <Route
                    path="/novoDependente"
                    element={<TelaNovoDependente />}
                  />
                  <Route
                    path="/alterarDependente"
                    element={<TelaAlterarDependente />}
                  />
                  <Route
                    path="/esqueciMinhaSenhaPF"
                    element={<EsqueciMinhaSenhaPF />}
                  />
                  <Route
                    path="/esqueciMinhaSenhaPJ"
                    element={<EsqueciMinhaSenhaPJ />}
                  />
                  <Route
                    path="/esqueciMinhaSenhaPJAN8"
                    element={<EsqueciMinhaSenhaPJAN8 />}
                  />
                  <Route
                    path="/esqueciMinhaSenhaPFSemCPF"
                    element={<EsqueciMinhaSenhaPFSemCPF />}
                  />
                  <Route
                    path="/historicoToken"
                    element={<FormHistoricoToken />}
                  />
                  <Route
                    path="/permitirDelegar"
                    element={<TelaPermitirTerceiroDelegar />}
                  />
                  <Route
                    path="/delegacaoAcesso"
                    element={<TelaDelegacaoAcesso />}
                  />
                  <Route
                    path="/delegacaoInclusao"
                    element={<TelaDelegacaoInclusao />}
                  />
                  <Route
                    path="/delegacaoEdicao"
                    element={<TelaDelegacaoEdicao />}
                  />
                  {/* <Route path="/permissaoSistema" element={<TelaPermissaoSistema />} />*/}
                  <Route path="/" element={<Home />} />
                  <Route path="/abrirNovaSessao" element={<AbirNovaSessao />} />
                  <Route path="/auth" element={<AuthCallback />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </main>

              {/* <Footer />*/}

              <Alerta />
              <ModalConfirmacao />
              <ModalInformacao />
            </UserStorage>
          </AuthStorage>
        </GlobalStorage>
      </BrowserRouter>
      <ToastContainer className="custom-toast-container" />
    </>
  );
}

export default App;
